import { Injectable } from '@angular/core'
import { AlertButton } from '@ionic/angular'
import { BehaviorSubject } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class AlertService {
	showsAlert$ = new BehaviorSubject<boolean>(false)

	alertMessage$ = new BehaviorSubject<string>('')

	alertButtons$ = new BehaviorSubject<AlertButton[]>([])

	showAlert(alertMessage: string, confirmHandler: () => void, rejectHandler?: () => void): void {
		// This updates the alertMessage to the alertMsg passed into the function
		this.alertMessage$.next(alertMessage)

		// This will update the showsAlert trigger to 'true'
		this.showsAlert$.next(true)

		// This will update the "OK" button click handler
		const buttons = [
			{
				text: 'Ok',
				role: 'confirm',
				handler: confirmHandler,
			},
		]

		if (rejectHandler) {
			buttons.push({
				text: 'Cancel',
				role: 'cancel',
				handler: rejectHandler,
			})
		}

		this.alertButtons$.next(buttons)
	}

	// This updates the showsAlert behaviour subject to 'false'
	dismissAlert(): void {
		this.showsAlert$.next(false)
	}
}
